import baseMessage from '../baseMessage'
import { merge, cloneDeep } from 'lodash'
import dictionary from './dictionary'
const cloneObj = cloneDeep(baseMessage)
const message = merge(cloneObj, dictionary)
export const PT_BR = {
  message
}
